import { z } from 'zod/v4';
import { createDefinitionSchema } from '../utils/helpers';

export enum TraceDataSource {
  Traces = 'Traces',
  Statistics = 'Statistics',
  Tags = 'Tags',
  TagsComparison = 'TagsComparison',
  Topology = 'Topology',
}

export type TraceQuerySpec = z.infer<typeof TraceQuerySpecSchema>;
const TraceQuerySpecSchema = z.object({
  // This query is a JSON serialized string of the TraceSearchRequest from the trace explorer.
  // This is a short-term solution to avoid passing in the entire query builder as part of this spec.
  // If this plugin is needed in a spec-driven use case (e.g. in dashboards), this should get broken
  // down into something more detailed so the specs get type-checked and formatted properly.
  query: z.string(),
  // Determines which trace endpoint to call when requesting data using the same dataTypeFilter
  data_source: z.enum([
    TraceDataSource.Traces,
    TraceDataSource.Statistics,
    TraceDataSource.Tags,
    TraceDataSource.TagsComparison,
    TraceDataSource.Topology,
  ]),
});

export type TraceQueryDefinition = z.infer<typeof traceQueryDefinitionSchema>;
export const traceQueryDefinitionSchema = createDefinitionSchema('TraceQuery', TraceQuerySpecSchema);
